<template>
  <div>
    <div class="cover" v-if="showStatus">
      <div class="pop">
        <p class="text1" v-if="locale == 'zh_cn'">{{ $t("select.welcome") }}</p>
        <p
          :class="{
            text3: locale == 'en_us' || locale == 'fr_fr',
            text2: locale == 'zh_cn',
          }"
        >
          {{ $t("select.chooseLau") }}
        </p>
        <div class="select">
          <RadioGroup v-model="radio" @on-change="changeLan">
            <Radio class="langSec" :label="2">
              <img class="langimg" :src="selectEn" alt="" />
              English
            </Radio>
            <Radio class="langSec" :label="3">
              <img class="langimg" :src="selectFr" alt="" />
              Français
            </Radio>
            <Radio class="langSec" :label="1" style="margin-right: 0">
              <img class="langimg" :src="selectZh" alt="" />
              中文
            </Radio>
          </RadioGroup>
        </div>
        <div
          :class="['confirm', { active: isEnter }]"
          @mouseover.stop="enter()"
          @mouseleave="leave()"
          @click="confirm"
        >
          {{ $t("select.confirm") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import selectZh from "../../assets/select_zh.png";
import selectEn from "../../assets/select_en.png";
import selectFr from "../../assets/select_fr.png";
import filter from "../../plugins/filters";
export default {
  name: "vselectLang",
  props: {
    showLang: Boolean,
  },
  data() {
    return {
      locale: "",
      showStatus: this.showLang,
      radio: "",
      selectZh: selectZh,
      selectEn: selectEn,
      selectFr: selectFr,
      isEnter: false,
    };
  },
  watch: {
    showLang(val) {
      this.showStatus = val;
    },
  },
  created() {
    this.locale = this._i18n.locale;
  },
  methods: {
    //检测是否已选择语言
    checkIsSelectLang() {
      if (this.radio == "") {
        alert("" + this.$t("select.chooseLau"));
        return false;
      }
      return true;
    },
    confirm() {
      if (!this.checkIsSelectLang()) return;
      // console.log(11111111);
      this.changeLang(this.radio);
      this.$emit("closeLang", false);
      if (filter.readData("cityInfo") != null) {
        this.$emit("getLang");
      }
    },
    changeLang(val) {
      this.$store.commit("set_langType", val);
      filter.setData("lang", val);
      if (val == 1) {
        this.$store.commit("set_lang", "zh_cn");
        this.$i18n.locale = "zh_cn";
      } else if (val == 2) {
        this.$store.commit("set_lang", "en_us");
        this.$i18n.locale = "en_us";
      } else if (val == 3) {
        this.$store.commit("set_lang", "fr_fr");
        this.$i18n.locale = "fr_fr";
      }
    },
    enter() {
      this.isEnter = true;
    },
    leave() {
      this.isEnter = false;
    },
    changeLan() {
      filter.setData("lang", this.radio);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../style/color.scss";
@import "../../style/base.scss";
.cover {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  .pop {
    width: 800px;
    height: 352px;
    margin: 180px auto;
    background: #fff;
    border-radius: 20px;
    padding: 30px 0;
    box-sizing: border-box;
    .text1 {
      font-size: 30px;
      color: $c_6DB;
      text-align: center;
    }
    .text2 {
      font-size: 14px;
      color: #333;
      // font-weight: 600;
      margin-bottom: 60px;
      text-align: center;
    }
    .text3 {
      font-size: 25px;
      color: $c_6DB;
      font-weight: 600;
      margin-bottom: 90px;
      text-align: center;
      font-family: EperFontBold;
    }
    .select {
      padding: 0 72px;
      box-sizing: border-box;
      margin-bottom: 70px;
      text-align: center;
      .langSec {
        margin-right: 82px;
        color: $c_000;
        font-family: EperFontLight;
        font-size: 17px;
      }
      .langimg {
        width: 54px;
        height: 54px;
        display: inline-block;
        vertical-align: middle;
      }
    }
    .confirm {
      width: 199px;
      height: 36px;
      // border: 1px solid $c_6DB;
      color: #fff;
      // background: $c_6DB;
      background: #000;
      border-radius: 20px;
      margin: 0 auto;
      text-align: center;
      line-height: 36px;
      font-size: 18px;
      cursor: pointer;
    }
    .confirm.active {
      // background: #000;
      color: #fff;
    }
  }
}
</style>

<style lang="scss">
// 覆盖样式
.select {
  .ivu-radio-checked .ivu-radio-inner {
    border-color: #000;
  }
  .ivu-radio-inner:after {
    background-color: #000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/selectLang.vue